import $ from "jquery";
import "slick-carousel";

// Insert your costum JS


class Carousel {
    run() {
        this.productSlider();
    }

    productSlider() {
        $('.hero-carousel').slick({
            mobileFirst: true,
            centerMode: true,
            dots: true,
            autoplay: true,
            arrows: false,
            // slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{

                breakpoint: 1024,
                settings: "unslick"

            }]
        });

        $('.products-carousel').slick({
            mobileFirst: true,
            centerMode: true,
            dots: true,
            infinite: true,
            autoplay: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{

                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    infinite: true,
                }

            }]
        });

        $('.applications-carousel').slick({
            mobileFirst: true,
            centerMode: true,
            dots: false,
            autoplay: true,
            arrows: false,
            // slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{

                breakpoint: 1024,
                settings: "unslick"

            }]
        });

        $('.product-list').slick({
            mobileFirst: true,
            centerMode: true,
            dots: false,
            autoplay: true,
            arrows: false,
            // slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            rewind: true,
            responsive: [{

                breakpoint: 414,
                settings: "unslick"

            }]
        });

        $(".center").slick({
            dots: false,
            infinite: true,
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 3
        });
        $('.product-gallery').slick({
            dots: true,
            infinite: true,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
}


const carousel = new Carousel();
export default carousel;
